import { render, staticRenderFns } from "./WalletTransactionHistoryTabs.vue?vue&type=template&id=2d0a220a"
import script from "./WalletTransactionHistoryTabs.vue?vue&type=script&lang=js"
export * from "./WalletTransactionHistoryTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports